







//- template(v-if="typeof(value) === 'object' && options.schema[identifier] !== 'latlng' && !Array.isArray(options.schema[identifier]) && options.schema[identifier] !== 'poly' ")
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {equals} from "../utils";

import {VTextField, VTextarea, VSelect, VFileInput, VDatePicker, VCheckbox} from "vuetify/lib";

import LatLng from "./fields/LatLng.vue";
import Hidden from "./fields/Hidden.vue";
import Editor from "./fields/Editor.vue";
import DatePicker from "./fields/DatePicker.vue";
import Poly from "./fields/Poly.vue";
import PictureUpload from "./fields/PictureUpload.vue";
import CheckBox from "./fields/CheckBox.vue";

@Component({
  components: {},
})

/**
 * This component models different form fields type
 */
export default class SmartFormField extends Vue {
  // Value passed by v-model
  @Prop() public readonly value: any
  @Prop() public readonly model: any

  // Type of field to rendered
  @Prop({default: null}) public readonly identifier!: string

  @Prop() public readonly options!: any

  // Holder for muted value
  public mutable: any = this.value


  // If the v-model is updated in the parent
  @Watch('value')
  public valueChanged(newValue: any, oldValue: any) {
    if (!equals(newValue, oldValue)) {
      // if(newValue.latitude && newValue.longitude) {}
      this.mutable = newValue

    }
  }

  @Watch('mutable')
  public mutableChanged() {
    // Send v-model value to parent
    this.$emit('input', this.mutable)
  }

  public type(t: string) {
    return this.options.schema[this.identifier] == t
  }

  public isNested() {
    return typeof (this.value) === 'object'
      && this.options.schema[this.identifier] !== 'latlng'
      && !Array.isArray(this.options.schema[this.identifier])
      && this.options.schema[this.identifier] !== 'poly'
  }

  /*    public b() {

        if(Array.isArray(this.options.schema[this.identifier])) {
          return {
            items: this.options.schema[this.identifier] // Qui va recuperata la lista, good luck
          }
        }

        return {
          placeholder: this.identifier,
          label: this.identifier,
        }
      }

      mounted() {
      }

      public c() {
        console.log(this.options.schema,this.identifier)
        if(Array.isArray(this.options.schema[this.identifier])){
          return VSelect
        }

        switch (this.options.schema[this.identifier]) {
          case 'text':
            return VTextarea
          case 'latlng':
            return LatLng
          case 'string':
            return VTextField
          default:
            console.warn('NO HANDLER FOR: ' + this.identifier + ' => ' + this.options.schema[this.identifier])
            return null
        }
      }*/

  public d(): { component: any, props: any } {
    let ret: { component: any, props: any } = {
      component: {},
      props: {
        placeholder: this.identifier,
        label: this.identifier,
      }
    }
    const schema = this.options.schema[this.identifier]

    // const type = schema.type ? schema.type : schema
    const type = schema
    if (Array.isArray(schema)) {
      ret.component = VSelect
      ret.props['items'] = this.options.schema[this.identifier]
      //console.log( "myvalue " + typeof (ret.props['items']))
      if (ret.props['items'].length > 0 && typeof (ret.props['items'][0]) === 'object') {
        //let val = ret.props['items'][0]

        ret.props['item-text'] = 'text'
        ret.props['item-value'] = 'val'
        //console.log(' text ' +val.text + ' value ' + val.val)
      }


    } else {
      switch (type) {
        case 'select':
          ret.component = VSelect
          ret.props['items'] = schema.items
          break
        case 'text':
          ret.component = VTextarea
          break
        case 'latlng':
          ret.component = LatLng
          break
        case 'string':
          ret.component = VTextField
          break
        case 'number':
          ret.component = VTextField
          ret.props['type'] = 'number'
          break
        case 'hidden':
          ret.component = Hidden
          break
        case 'editor':
          ret.component = Editor
          break
        case 'picture':
          ret.component = PictureUpload
          break
        case 'date':
          ret.component = DatePicker
          break
        case 'checkbox':
          ret.component = CheckBox
          break
        case 'poly':
          ret.component = Poly
          break
        default:
          console.warn('NO HANDLER FOR: ' + this.identifier + ' => ' + this.options.schema[this.identifier])
          ret.component = Hidden
          break

      }
    }

    if (schema && schema.props) {
      Object.keys(schema.props).forEach(k => {
        ret.props[k] = schema.props[k]
      })
    }


    return ret;
  }
}


